import React, {useState} from 'react';
import {connect} from "react-redux";
import {withRouter} from "../../../../utils/services/with-router";
import {CustomLink, StyledCard, StyledDiv} from "./LoginCard.styled";
import {Button, Card, Flex, Form, Input, message} from "antd";
import style from "./LoginCard.module.scss";
import LoginOtpForm from "./LoginOtpForm";
import {generateOTp} from "../../actions/userManagement.action";
import {LoginCardProps} from "../../models";
import {enumUtil} from "zod/lib/helpers/enumUtil";
import {StyledDTitleDiv} from "../../pages/loginPage/Login.styled";
import {CloseOutlined} from "@ant-design/icons";
import {useNavigate} from "react-router-dom";

const LoginCard = ({generateOTp}: LoginCardProps) => {
    const [form] = Form.useForm();
    const navigate = useNavigate()
    const [showOtp, setShowOtp] = useState<boolean>(false)
    const [loading, setLoading] = useState<boolean>(false)
    const [mobileNumber, setMobileNumber] = useState<string>("")
    const [secondsLeft, setSecondsLeft] = useState<number>()
    const onFinish = async (value: any) => {
        setLoading(true)
        generateOTp(value).then((data: any) => {
            setLoading(false);
            if (data.payload) {
                if (data.payload?.data != null) {
                    setShowOtp(true)
                    setMobileNumber(value.mobileNumber)
                    setSecondsLeft(data.payload?.data?.secondsLeft)
                } else message.error(data?.payload?.error.message)
            }
        });
    }
    return (
        <StyledCard>
            <Flex vertical gap={"large"} align={"center"} justify={"center"}>
              <Flex justify={"start"} style={{width:"100%"}}>
                  <CloseOutlined onClick={() => navigate('/')} />
              </Flex>
                <StyledDTitleDiv>

                    <img width={120} src={require("assets/Logo/typographyPink.png")}/>

                    <small className={style.description}>پلتفرم آنلاین اجاره تجهیزات و لوازم</small>
                </StyledDTitleDiv>

                {showOtp ?
                    <LoginOtpForm secondsLeft={secondsLeft} mobileNumber={mobileNumber}
                                         onEdit={() => setShowOtp(false)}/> :
                    <Form onFinish={onFinish}>
                        <Flex vertical gap={"small"}>

                            <Form.Item
                                rules={[
                                    {required: true, message: "شماره موبایل خود را وارد کنید."},
                                    {
                                        pattern: /^09\d{9}$/,
                                        message: "شماره موبایل را 11 رقمی و با 09 وارد کنید.",
                                    },
                                ]}
                                name="mobileNumber"
                                label="شماره موبایل"
                            >
                                <Input variant={"outlined"} size="large" placeholder="مثال : 0912345678"/>
                            </Form.Item>
                            <Button loading={loading} type={"primary"} htmlType={"submit"}>دریافت کد یکبار مصرف</Button>
                            <span>
                                <CustomLink href="/conditions" target="_self"
                                   rel="noopener noreferrer" className={style.noUnderline}>شرایط استفاده از خدمات</CustomLink> و <CustomLink href="/terms"
                                                                                             target="_self"
                                                                                             rel="noopener noreferrer" className={style.noUnderline}>حریم خصوصی</CustomLink> پلتفرم  «پیدا» را می‌پذیرم.
                           </span>
                        </Flex>
                    </Form>


                }
            </Flex>
        </StyledCard>
    );
};

export default connect(null, {generateOTp})(withRouter(LoginCard));
